import React from 'react';
import styled from 'styled-components';
import Spinner from './Spinner';

const SpinnerWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    justify-content: center;
    align-items: center;
`;

export const LoadingPage = () => (
    <SpinnerWrapper>
        <Spinner />
    </SpinnerWrapper>
);
